export default [
  {
    path: "/",
    text: "about us",
  },
  {
    path: "/services",
    text: "services",
  },
  {
    path: "/gallery",
    text: "gallery",
  },
  {
    path:"/coupon",
    text: "coupon"
  },
  {
    path: "/location",
    text: "location",
  },
]
